import type { TableColumns } from '@ohpen/enso-ui';
import { FieldType, IntermediaryGetAll, IntermediaryDraftDataRow } from '@pmp/api';

export const columns: TableColumns<IntermediaryGetAll> = [
  {
    title: 'lender.brokers.labels.id',
    dataIndex: 'id',
    key: 'id',
    options: {
      filter: 'search',
      sorter: true,
      hide: true,
    },
    fixed: 'left',
  },
  {
    title: 'lender.brokers.labels.fullName',
    dataIndex: 'displayName',
    key: 'displayName',
    options: {
      filter: 'search',
      sorter: true,
    },
  },
  {
    title: 'lender.brokers.labels.email',
    dataIndex: 'email',
    key: 'email',
    options: {
      filter: 'search',
      sorter: true,
    },
  },
  {
    title: 'lender.brokers.labels.roles',
    dataIndex: 'roles',
    key: 'roles',
    width: 120,
    options: {
      format: {
        type: 'multiValueList',
      },
      filter: 'select',
      listName: FieldType.USER_ROLE_TYPE,
    },
  },
  {
    title: 'lender.brokers.labels.irnNumber',
    dataIndex: 'irn',
    key: 'irn',
    options: {
      filter: 'search',
      sorter: true,
    },
  },
  {
    title: 'lender.brokers.labels.firmName',
    dataIndex: 'firmName',
    key: 'firmName',
    options: {
      filter: 'search',
      sorter: true,
    },
  },
  {
    title: 'lender.brokers.labels.firmFRN',
    dataIndex: 'firmFRN',
    key: 'firmFRN',
    options: {
      filter: 'search',
      sorter: true,
    },
  },
  {
    title: 'lender.brokers.labels.tradingAddress',
    dataIndex: 'tradingAddress',
    key: 'tradingAddress',
    options: {
      filter: 'search',
      sorter: true,
    },
  },
  {
    title: 'lender.brokers.labels.complianceStatus',
    dataIndex: 'compliance',
    key: 'compliance',
    width: 130,
    options: {
      format: {
        type: 'valueList',
      },
      filter: 'select',
      listName: FieldType.COMPLIANCE_STATUS,
      sorter: true,
    },
  },
  {
    title: 'lender.brokers.labels.activationStatus',
    dataIndex: 'userStatus',
    key: 'userStatus',
    options: {
      format: {
        type: 'valueList',
      },
      filter: 'select',
      listName: FieldType.USER_STATUS,
    },
  },
  { title: 'global.labels.actions', dataIndex: '', key: 'actions', width: 100, fixed: 'right' },
];

export const intermediaryCRColumns: TableColumns<IntermediaryDraftDataRow> = [
  {
    title: 'lender.brokers.labels.email',
    dataIndex: 'email',
    key: 'email',
    width: 200,
    options: { sorter: true },
  },
  {
    title: 'lender.brokers.labels.firstName',
    dataIndex: 'firstName',
    key: 'firstName',
    width: 120,
    options: { sorter: true },
  },
  {
    title: 'lender.brokers.labels.lastName',
    dataIndex: 'lastName',
    key: 'lastName',
    width: 120,
    options: { sorter: true },
  },
  {
    title: 'lender.brokers.labels.fullName',
    dataIndex: 'displayName',
    key: 'displayName',
    width: 150,
    options: { sorter: true },
  },
  {
    title: 'lender.brokers.labels.mobile',
    dataIndex: 'mobilePhoneNumber',
    key: 'mobilePhoneNumber',
    width: 150,
    options: { sorter: true },
  },
  {
    title: 'lender.brokers.labels.telephone',
    dataIndex: 'workPhoneNumber',
    key: 'workPhoneNumber',
    width: 150,
    options: { sorter: true },
  },
  {
    title: 'lender.brokers.labels.irnNumber',
    dataIndex: 'irn',
    key: 'irn',
    width: 120,
    options: { sorter: true },
  },
  {
    title: 'lender.brokers.labels.reference',
    dataIndex: 'ohpenId',
    key: 'ohpenId',
    width: 120,
    options: { sorter: true },
  },
  {
    title: 'lender.brokers.labels.roles',
    dataIndex: 'roles',
    key: 'roles',
    width: 120,
    options: {
      format: { type: 'multiValueList' },
      listName: FieldType.USER_ROLE_TYPE,
    },
  },
  {
    title: 'lender.brokers.labels.fcaStatus',
    dataIndex: 'fcaStatus',
    key: 'fcaStatus',
    width: 120,
    options: { sorter: true },
  },
  {
    title: 'lender.brokers.labels.marketingMaterials',
    dataIndex: 'receiveMarketingMaterials',
    key: 'receiveMarketingMaterials',
    width: 130,
    options: {
      format: { type: 'boolean' },
      listName: FieldType.YES_NO,
    },
  },
  {
    title: 'lender.brokers.labels.termsAndConditions',
    dataIndex: 'agreedToTermsAndConditions',
    key: 'agreedToTermsAndConditions',
    width: 130,
    options: {
      format: { type: 'boolean' },
      listName: FieldType.YES_NO,
    },
  },
  {
    title: 'lender.brokers.labels.complianceChecks',
    dataIndex: 'consentToComplianceChecksBeingCarriedOut',
    key: 'consentToComplianceChecksBeingCarriedOut',
    width: 130,
    options: {
      format: { type: 'boolean' },
      listName: FieldType.YES_NO,
    },
  },
];
